import { Box, Grid, Typography } from "@mui/joy";
import { AnimatePresence, motion } from "framer-motion";
import { useLabor } from "../hooks/useLabor";
import { LaborCard } from "./LaborCard";
import { LaborSkeleton } from "../skeletons";
import { SupplierComparisonRefresh as SupplierComparison } from "../../..";
import { Wrench } from "lucide-react";

interface LaborProps {
    measurements: any[];
}

export default function Labor({ measurements }: LaborProps) {
    const {
        laborSchema,
        selectedValues,
        adaptedSelectedValues,
        priceRanges,
        isLoading,
        handleQuantityUpdate,
        handleClearLabor,
    } = useLabor({ measurements });

    return (
        <AnimatePresence mode="popLayout">
            {isLoading ? (
                <motion.div
                    key="skeleton"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                >
                    <LaborSkeleton />
                </motion.div>
            ) : laborSchema.length === 0 ? (
                <motion.div key="empty" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                    <Box
                        p={4}
                        textAlign="center"
                        sx={{ border: "1px dashed", borderColor: "divider", borderRadius: "md" }}
                    >
                        <Typography level="body-sm" color="neutral">
                            No labor items identified for this project.
                        </Typography>
                    </Box>
                </motion.div>
            ) : (
                <motion.div
                    key="content"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <Box>
                        <Box mb={2}>
                            <Typography level="title-md" startDecorator={<Wrench size={16} />}>
                                Labor & Service Scopes
                            </Typography>
                            <Typography level="body-sm" color="neutral">
                                Crew assignments, installation services, and project labor rates.
                            </Typography>
                        </Box>

                        <Grid container spacing={1.5}>
                            {laborSchema.map((item: any) => (
                                <Grid xs={12} key={item.Id}>
                                    <LaborCard
                                        laborItem={item}
                                        selection={selectedValues[item.Id]}
                                        priceRange={priceRanges[item.Id]}
                                        onQuantityChange={(serviceId, direction) =>
                                            handleQuantityUpdate(serviceId, direction)
                                        }
                                        onRemove={(serviceId) => handleClearLabor(serviceId)}
                                    />
                                </Grid>
                            ))}
                        </Grid>

                        {/* Labor Supplier Comparison & Selection */}
                        <Box mt={4}>
                            <SupplierComparison type="LABOR" selectedValues={adaptedSelectedValues} />
                        </Box>
                    </Box>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
